// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6o-0";
export var startPickingButton = "_6o-1";